<template>
  <div class="wrapper">
   <div id="javascriptComponents">
    <div class="md-layout">
      <div class="md-layout-item md-size-66 mx-auto md-small-size-100">
        <md-card>
          <carousel
            :per-page="1"
            loop
            :speed="700"
            autoplay
            :autoplay-timeout="5000"
            :mouse-drag="false"            
          >
            <slide>
              <img :src="carousel1" />
            </slide>
            <slide>
              <img :src="carousel2" />
            </slide>
            <slide>
              <img :src="carousel3" />
            </slide>
            <slide>
              <img :src="carousel4" />
            </slide>
          </carousel>
        </md-card>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      carousel1: require("@/assets/home/slide7.jpeg"),
      carousel2: require("@/assets/home/slide5.jpeg"),
      carousel3: require("@/assets/home/slide2.jpg"),
      carousel4: require("@/assets/home/slide3.jpg")
    };
  }
};
</script>